import { flatten, values } from "lodash";
import { ExportType, Frequency } from "PFApp/booking/types/export_booking";
import { Alert } from "PFComponents/alert";
import PageTabs from "PFComponents/page/page_tabs";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useExportWizardModalContext } from "../export_wizard_modal_provider";
import { decamelizeFilters } from "./export_fields_utils";
import css from "./export_wizard_content.module.scss";
import { useExportWizardTabs } from "./use_export_wizard_tabs";

export const ExportWizardContent = (): JSX.Element => {
  const { t } = useTranslation("bookingModule", { keyPrefix: "reports.exportWizard" });
  const {
    state: {
      data: { exportType, selectedFields, selectedTemplate }
    },
    updateData
  } = useExportWizardModalContext();

  const { currentTab, tabs, handleClickTab, TabComponent } = useExportWizardTabs();

  const hasNoFieldsSelected = !selectedFields?.length;

  useEffect(() => {
    if (selectedTemplate && exportType === ExportType.Template) {
      const { aggregateBy, fields, filters } = selectedTemplate;
      updateData({
        frequency: (aggregateBy || Frequency.Daily) as Frequency,
        selectedFields: flatten(values(fields).map((val) => values(val))),
        selectedFilters: decamelizeFilters(filters)
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTemplate]);

  return (
    <div className={css.exportWizardContent}>
      <PageTabs
        rootClassName={css.tabs}
        items={tabs}
        active={currentTab}
        handleClick={handleClickTab}
        capitalize={false}
      />
      {hasNoFieldsSelected && (
        <Alert kind="warning" title={t("noFieldsSelectedTitle")}>
          {t("noFieldsSelected")}
        </Alert>
      )}
      <TabComponent />
    </div>
  );
};
